import getAPIPath from '../modules/api-location';

window.updateClubInfoService = function(data, successFn, errorFn) {
    return $.ajax({
        url: `${getAPIPath}commandapi/club/info`,
        type: 'put',
        data: data,
        success: successFn,
        error: errorFn,
        async: true,
        dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

    });
};

window.createClubService = function(data, successFn, errorFn) {
    return $.ajax({
        url: `${getAPIPath}commandapi/club/create`,
        type: 'post',
        data: data,
        success: successFn,
        error: errorFn,
        async: true,
        dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

    });
};

window.updateClubSocialService = function(data, successFn, errorFn) {
    return $.ajax({
        url: `${getAPIPath}commandapi/club/social`,
        type: 'put',
        data: data,
        success: successFn,
        error: errorFn,
        async: true,
        dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },
    });
};

window.updateClubThemeService = function(formData, successFn, errorFn) {

    return $.ajax({
        url: `${getAPIPath}commandapi/club/theme`,
        type: "post",
        data: formData,
        cache: false,
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },
        success: successFn,
        error: errorFn

    });

};

window.updateClubColourService = function(data, successFn, errorFn) {
    return $.ajax({
        url: `${getAPIPath}commandapi/club/colour`,
        type: 'put',
        data: data,
        success: successFn,
        error: errorFn,
        async: true,
        dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

    });

};

window.addAdminToClubService = function(clubId, emailAddress, grant, successFn, errorFn) {
  const item = {};
  item.club_Id = clubId;
  item.email_address = emailAddress;
  item.grant = grant;

    return $.ajax({
        url: `${getAPIPath}commandapi/add-admin-to-club`,
        type: 'put',
        data: JSON.stringify(item),
        success: successFn,
        error: errorFn,
        async: true,
        dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

    });

};

window.clubRemoveAdminService = function(memberID, clubID, successFn) {
    return $.ajax({
        url: `${getAPIPath}queryapi/remove-admin-from-club?club_id=${clubID}&user_id=${memberID}`,
        type: 'delete',
        success: successFn,
        async: true,
        dataType: 'json',
        xhrFields: {
          withCredentials: true,
        },

    });
};



// WEBPACK FOOTER //
// ./library/js/services/club.service.js